import React, { useMemo } from 'react'

import { useAppDispatch, useAppSelector } from '@App/hooks'
import { sendDeleteAccountConnection } from '@Redux/slices/sockets/ProxyServiceConnectionSlice'
import { ModalTypes } from '../modalTypes'
import ModalWrapper from '../ModalWrapper'

import { Wallet } from '@Interfaces/CommonInterfaces'

import s from './DeleteAccountModal.module.scss'
import { CloseIcon } from '@Static/icons/DepositPageIcons'

import { Button } from '@UI/crypto_exchange/desktop/components/controls/Button'

interface Props {
  wallet: Wallet
}

export const DeleteAccountModal = ({ isOpen, setIsOpen, wallet }: ModalTypes & Props) => {
  const dispatch = useAppDispatch()

  const { trades, orders } = useAppSelector((state) => {
    const accountKey = String(wallet.id)

    return {
      trades: state.trades.tradesList?.[accountKey] ?? [],
      orders: state.orders.ordersList?.[accountKey] ?? [],
    }
  })

  const hasActivePositions = useMemo(
    () => trades.length > 0 || orders.length > 0,
    [trades, orders],
  )

  const handleDelete = () => {
    dispatch(sendDeleteAccountConnection(Number(wallet.id)))
    setIsOpen()
  }

  const handleSupport = () => {
    window.open('/support', '_blank')
    setIsOpen()
  }

  return (
    <ModalWrapper isOpen={isOpen} setIsOpen={setIsOpen}>
      <div className={s.modal}>
        <CloseIcon className={s.closeIcon} onClick={setIsOpen} />

        {!hasActivePositions ? (
          <>
            <h1 className={s.title}>
              Would you like to delete <b>"{wallet.name}"</b> account?
            </h1>

            <p className={s.desc} />

            <div className={`${s.actions} ${s.stretched}`}>
              <Button onClick={setIsOpen} className={s.cancelBtn}>
                Cancel
              </Button>

              <Button onClick={handleDelete} className={s.deleteBtn} color="delete">
                Delete
              </Button>
            </div>
          </>
        ) : (
          <>
            <h1 className={s.title}>
              Steps required to close your account
            </h1>

            <p className={s.desc}>
              Before closing your demo account, please ensure there are no open
              positions or pending orders.
              <br />
              <br />
              For more details, contact support.
            </p>

            <div className={`${s.actions} ${s.vertical} ${s.stretched}`}>
              <Button onClick={setIsOpen} className={s.cancelBtn}>
                Got it
              </Button>

              <Button onClick={handleSupport} className={s.supportBtn} color="alternative">
                Contact support
              </Button>
            </div>
          </>
        )}
      </div>
    </ModalWrapper>
  )
}
